import React from "react";
import { formatMomentDate } from "../../utils/dateHelper";
import StatusChip from "../../components/statusChip/StatusChip";
import { routes } from "../../routes/pageRoutes";
import CustomTable from "../../components/table/CustomTable";

const MarketplaceListSection = ({
    data,
    navigate,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    isLoading,
    isInitialLoad,
    actionList
}) => {

    const getStatusBg = (status) => {
        const lowerStatus = status?.toLowerCase();
        switch (lowerStatus) {
            case "pending":
                return "warning";
            case "approved":
                return "success";
            case "published":
                return "blue";
            case "rejected":
                return "danger";
            case "closed":
                return "secondary";
            case "sold":
                return "blue";
            default:
                return "";
        }
    };

    const pagination = {
        currentPage,
        totalPages: Math.ceil((totalItems || 0) / (pageSize || 10)),
        total: totalItems || 0,
        onPageChange: (page) => setCurrentPage(page),
        pageSize: pageSize || 10,
        setPageSize,
        setCurrentPage,
        perPageOptions: [10, 20, 50, 100],
    };

    const columns = [
        {
            id: "offer_name",
            header: "OFFER NAME",
            cell: (_, row) => {
                const firstPhoto = row?.photos?.[0]?.url;
                return (
                    <div className="d-flex align-items-center gap-2">
                        {firstPhoto ? (
                            <img src={firstPhoto} alt="Offer" width={30} height={30} className="rounded object-fit-cover" />
                        ) : (
                            <div className="rounded bg-light d-flex align-items-center justify-content-center" style={{ width: 30, height: 30, fontSize: 10 }}>Img</div>
                        )}
                        <span className="text-nowrap">{row.name || "-"}</span>
                    </div>
                );
            }
        },
        {
            id: "category",
            header: "CATEGORY",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.category?.name || "-"}</span>
            )
        },
        {
            id: "seller",
            header: "SELLER DETAILS",
            cell: (_, row) => {
                const sellerPhoto = row?.user?.profile?.profile_photo?.url;
                const sellerName = row?.user ? `${row.user.first_name} ${row.user.last_name}` : "-";
                return (
                    <div className="d-flex align-items-center gap-2">
                        {sellerPhoto ? (
                            <img src={sellerPhoto} alt="Seller" width={30} height={30} className="rounded-circle object-fit-cover" />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 30, height: 30, fontSize: 10 }}>User</div>
                        )}
                        <div className="d-flex flex-column text-start">
                            <span className="fw-medium text-nowrap">{sellerName}</span>
                            <span className="text-secondary small">{row?.user?.mobile_number || "-"}</span>
                        </div>
                    </div>
                );
            }
        },
        {
            id: "state",
            header: "STATE",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.state?.name || "-"}</span>
            )
        },
        {
            id: "city",
            header: "CITY",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.city?.name || "-"}</span>
            )
        },
        {
            id: "mrp",
            header: "MRP",
            cell: (_, row) => {
                const mrp = row?.user_listing_details?.mrp || 0;
                return (
                    <span className="small text-nowrap">{mrp ? `₹ ${mrp}` : "-"}</span>
                );
            }
        },
        {
            id: "price",
            header: "PRICE",
            cell: (_, row) => {
                const price = row?.user_listing_details?.price || 0;
                return (
                    <span className="small text-nowrap">{price ? `₹ ${price}` : "Negotiable"}</span>
                );
            }
        },
        {
            id: "discount",
            header: "DISCOUNT",
            cell: (_, row) => {
                const discount = row?.user_listing_details?.discount || 0;
                return (
                    <span className="small text-nowrap text-success">{discount > 0 ? `${Number(discount)}%` : "0.00%"}</span>
                );
            }
        },
        {
            id: "status",
            header: "STATUS",
            cell: (_, row) => row?.status ? (
                <StatusChip
                    bg={getStatusBg(row.status)}
                    pill
                    title={row.status}
                    className="text-capitalize"
                />
            ) : "-"
        },
        {
            id: "created_at",
            header: "CREATED AT",
            cell: (_, row) => (
                <span className="small text-nowrap">
                    {row?.created_at ? formatMomentDate(row.created_at, "DD-MM-YYYY hh:mm A") : "-"}
                </span>
            )
        }
    ];

    return (
        <CustomTable
            data={data || []}
            columns={columns}
            loading={isLoading && !isInitialLoad}
            emptyMessage="No listings found"
            keyField="id"
            pagination={pagination}
            actionList={actionList}
            rowClick={(row) => {
                const targetRoute = row.seller_type === 'company'
                    ? routes.viewMarketplaceBulkOffer.replace(":id", row.id)
                    : routes.viewMarketplaceListing.replace(":id", row.id);
                navigate(targetRoute, { state: { currentPage: currentPage } });
            }}
        />
    );
};

export default MarketplaceListSection;
